import { render } from "./Self.vue?vue&type=template&id=77bad53a"
import script from "./Self.vue?vue&type=script&lang=js"
export * from "./Self.vue?vue&type=script&lang=js"

import "./Self.vue?vue&type=style&index=0&id=77bad53a&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_yg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__